export default __webpack_public_path__ + "static/media/StretchPro.c191288a.otf";